import { useTranslation } from 'next-i18next';
import { Select, SelectItemType } from '@zep/ui';
import { useSubscriptionPaymentContext } from '../hooks';
import S from '../SubscriptionPayment.module.scss';
export const PlanSelectMaxCcu = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    selectedMaxCcu,
    handleSelectedMaxCcu,
    selectedPlan,
    spacePlanProducts,
    isAnnuallyPayment
  } = useSubscriptionPaymentContext();
  const selectOptions: SelectItemType[] = (() => {
    if (selectedPlan === 'enterprise') {
      return spacePlanProducts.ENTERPRISE.filter(({
        subscriptionPeriod
      }) => {
        return isAnnuallyPayment ? subscriptionPeriod === 365 : subscriptionPeriod === 30;
      }).map(d => ({
        value: d.maxCcu.toString(),
        name: d.maxCcu < 0 ? t('subscription:pricing.calculation.barUnlimited') : t('subscription:pricing.plansCommon.peopleNumber', {
          ccu: d.maxCcu
        })
      }));
    }
    if (selectedPlan === 'pro') {
      return spacePlanProducts.PRO.filter(({
        subscriptionPeriod
      }) => {
        return isAnnuallyPayment ? subscriptionPeriod === 365 : subscriptionPeriod === 30;
      }).map(d => ({
        value: d.maxCcu.toString(),
        name: d.maxCcu < 0 ? t('subscription:pricing.calculation.barUnlimited') : t('subscription:pricing.plansCommon.peopleNumber', {
          ccu: d.maxCcu
        })
      }));
    }
    return spacePlanProducts.BASIC.filter(({
      subscriptionPeriod
    }) => {
      return isAnnuallyPayment ? subscriptionPeriod === 365 : subscriptionPeriod === 30;
    }).map(({
      maxCcu,
      status
    }) => ({
      value: maxCcu.toString(),
      name: maxCcu < 0 ? t('subscription:pricing.calculation.barUnlimited') : t('subscription:pricing.plansCommon.peopleNumber', {
        ccu: maxCcu
      }),
      disabled: status == '0'
    }));
  })();
  const onChangeCount = ({
    value
  }: SelectItemType) => {
    handleSelectedMaxCcu(Number(value));
  };
  const value = selectOptions.filter(so => Number(so.value) === selectedMaxCcu)[0];
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  }} data-sentry-component="PlanSelectMaxCcu" data-sentry-source-file="PlanSelectMaxCcu.tsx">
      <div style={{
      gap: 4,
      display: 'flex',
      flexDirection: 'column'
    }}>
        <span className={S.section_title}>
          {t('subscription:payment.planSelect.subtitleCcu')}
        </span>
        <span className={S.section_sub_title}>
          {t('subscription:payment.planSelect.ccuDescription')}
        </span>
      </div>

      <Select width={'200px'} onChange={onChangeCount} size={'md'} value={value} options={selectOptions} optionsHeight={'max-content'} data-sentry-element="Select" data-sentry-source-file="PlanSelectMaxCcu.tsx" />
    </div>;
};